// removed by extract-text-webpack-plugin
module.exports = {"Box":"_1wFLn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hotel/HotelTuple/TupleBoxLeft/TupleBoxLeft.scss
// module id = 895
// module chunks = 0